exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TopRight-module__wrapper___2r8Pc{display:grid;grid-auto-flow:column;gap:.75rem}.TopRight-module__wrapper___2r8Pc .TopRight-module__delete___1p1ED{color:#fc156d}.TopRight-module__wrapper___2r8Pc .TopRight-module__mail___3shoz{color:#0827e9}.TopRight-module__wrapper___2r8Pc button{display:block;font-size:14px}", ""]);

// exports
exports.locals = {
	"wrapper": "TopRight-module__wrapper___2r8Pc",
	"delete": "TopRight-module__delete___1p1ED",
	"mail": "TopRight-module__mail___3shoz"
};